import { createFileRoute } from "@tanstack/react-router";

import ManageCreditSystem from "@/components/ManageCreditSystem/ManageCreditSystem";

export const Route = createFileRoute("/gym/$venueUuid/settings/credits")({
  component: ManageCreditSystem,
});
